import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import Colors from '../../../../constants/Colors';
import Style from '../../../../constants/Style';
import PressableStyled from '../../../PressableStyled';
import UpArrow12 from '../../../12pxIcons/UpArrow12';
import RightArrow20 from '../../../24pxIcons/RightArrow20';

interface AverageUtilizationTileProps {
  name: string,
  value: number,
  difference?: number,
}

const AverageUtilizationTile = ({ name, value, difference }: AverageUtilizationTileProps) => {
  const improvement: boolean = difference < 0;

  return <View style={styles.wrapper}>
    <View style={styles.container}>
      <View style={[Style.row, styles.header]}>
        <Text style={styles.name}>{name ?? '-'}</Text>
        <PressableStyled style={styles.icon}>
          <RightArrow20 />
        </PressableStyled>
      </View>
      <Text style={styles.label}>{'Average utilization'}</Text>
      <Text style={styles.value}>{`${value ?? '-'}%`}</Text>
      {typeof difference === 'number' && !!difference && <View style={styles.differenceSection}>
        <UpArrow12
          color={improvement ? styles.improvement.color : styles.differenceValue.color}
          style={{ transform: [{ rotate: improvement ? '180deg' : '0deg' }] }}
        />
        <Text style={[styles.label, styles.differenceValue, improvement && styles.improvement]}>
          {`${Math.abs(Math.round(difference))}%`}
        </Text>
        <Text style={[styles.label, styles.differenceLabel]}>{'Difference from [period]'}</Text>
      </View>}
    </View>
  </View>;
};

const styles = StyleSheet.create({
  header: {
    height: 24,
  },
  wrapper: {
    paddingHorizontal: 2,
    width: '50%',
  },
  container: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.light.hereworksWhite300,
    backgroundColor: '#FFF',
    marginBottom: 4,
  },
  name: {
    fontSize: 16,
    lineHeight: 24,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Poppins_400Regular',
    marginBottom: 8,
  },
  label: {
    fontSize: 14,
    lineHeight: 22,
    color: Colors.light.hereworksBlack400,
    fontFamily: 'Roboto_400Regular',
  },
  value: {
    fontSize: 18,
    lineHeight: 14,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Poppins_600SemiBold',
    marginTop: 4,
  },
  differenceSection: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
  },
  differenceValue: {
    color: Colors.light.hereworksRed700,
  },
  improvement: {
    color: Colors.light.hereworksGreen600,
  },
  differenceLabel: {
    marginStart: 4,
  },
  icon: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
});

export default AverageUtilizationTile;
